<div class="uc-message-container">
  <uc-message-item
    *ngFor="let message of messages; index as i"
    [index]="i"
    [message]="message"
  ></uc-message-item>
</div>
